module.exports = __webpack_public_path__ + "static/media/bilingual-asia-miles.b096f020.jpg";